export default "__VITE_ASSET__DqenUj$T__"